import React from 'react'
import "./Style.css"
import { Button, Divider } from '@mui/material';
import LabelInput from '../../LabelInputFields/Index';
import CloseIcon from '@mui/icons-material/Close';
import { APIUrlThree, APIUrlToken } from '../../../Utils/Utils';
import axios from 'axios';
import { toast } from 'react-toastify';
import Loader from '../../Loader/Loader';
const OrganizationSearch = () => {
    const [Fromalldata, setFromalldata] = React.useState("")
    const [ResponseData, setResponseData] = React.useState(null)    
    const [showAutocomplete, setShowAutocomplete] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [noSearch, setNoSearch] = React.useState(false);
    const [orgId, setOrgId] = React.useState();
    const handlesearch = () => {
        setLoading(true)
        const data = {
            org_name: Fromalldata
        };
        axios.post(`${APIUrlThree()}/v1/org_search`, data, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                "X-API-Key": APIUrlToken()
            }
        })
            .then(response => {
                
                setLoading(false)
                if (response.status === 200) {
                    setResponseData(response.data);
                }
            })
            .catch(error => {
                setLoading(false)
                toast.error(error.response.message);
            });
    };
    React.useEffect(() => {
        let timer
        if (Fromalldata.length > 2 && noSearch == false) {
            timer = setTimeout(() => {
                handlesearch();
            }, 1000);
        }else{
            setNoSearch(false)
        }
        return () => clearTimeout(timer)
    }, [Fromalldata]);
    const hnadelClearnew = () => {
        setFromalldata("")
        setResponseData(null)
        setNoSearch(false)
    }
    const handelselectdata = (item) => {
        setNoSearch(true)
        setResponseData(null)
        setFromalldata(item.org_name);
        setShowAutocomplete(false)
        setOrgId(item?.id)
    };
    const handleRightsidebar = () => {
        setLoading(true)
        const option = {
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "content-type": "application/json",
            "X-API-Key": APIUrlToken()
          },
          url: `${APIUrlThree()}/v1/ai_path_organization?orgid=${orgId}`,
        };
        axios(option)
          .then((response) => {
            setLoading(false);
            if (response?.status === 200) {
              setFromalldata("")
              
            //   const data = Object.values(response?.data)
            //   setDataShortestPath(data);
            }
          })
          .catch((err) => {
            setLoading(false)
            toast.error(err?.response?.data?.message);
          });
    }

    return (
        <>
        {loading ? <Loader/>:null}
        <div className='main-for-search-ai-path'>
            <div className='organization-search-ai-path'>
                <div><p className='search-ai-path-head'>Organization AI Path Search</p></div>
                <div className='inputs-button-search-org'>
                    <div className='inner-boxs-org'>
                        <label htmlFor="" className='label-search-aipath-component'>Search by Organization</label>
                        <div className='inputs-in-search-ai-path'>
                            <LabelInput
                                placeholder="Organization"
                                value={Fromalldata}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    setFromalldata(inputValue);
                                    setShowAutocomplete(true);

                                }}
                            />
                            <div onClick={hnadelClearnew} className='close-icns'>
                                {Fromalldata && (
                                    <CloseIcon />
                                )}
                            </div>
                        </div>
                        {showAutocomplete && (
                            <div className='setposition'>
                                <div className={ResponseData === "" || ResponseData?.length > 0 ? 'Autocompleteaipath' : "sethjgcghjiohgh"}>
                                    {ResponseData && ResponseData.length > 0 ? (
                                        ResponseData?.map((item) => {
                                            return (
                                                <>
                                                    <div className='innerAutocomplete' onClick={() => handelselectdata(item)} key={item.id}>
                                                        {item.org_name}
                                                    </div>
                                                    <div className='separatorline'></div>
                                                </>
                                            )
                                        })
                                    ) : (
                                        <div className={ResponseData?.length === 0 ? 'notAvailable' : "degtyrrf"}>
                                            {Fromalldata?.length || ResponseData?.length === 0 ? "Not available" : ""}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className='inner-boxs-serch-path'>
                        <Button style={{ textTransform: 'none' }} className='search-aipath-button-component' onClick={handleRightsidebar}>Search AI Path</Button>
                    </div>
                </div>
            </div>
        </div >
        </>
    )
}

export default OrganizationSearch